// extracted by mini-css-extract-plugin
export default {"status-icon":"vendorColumns_status-icon__vVW27"};